import { actionTypes } from '~/constants';

const initialState = {
    list: [],
    detail: null,
    is_loaded: false
};

export default (state = initialState, action) => {
    let index;
    switch(action.type) {
        case actionTypes.ACCIDENTS_CLEAR_DETAIL:
            return {
                ...state,
                detail: null,
                is_loaded: true,
            }
        case actionTypes.ACCIDENTS_FETCH_ALL:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.ACCIDENTS_FETCH_ALL_SUCCESS:
            return {
                ...state,
                list: action.accidents,
                is_loaded: true
            }
        case actionTypes.ACCIDENTS_FETCH_ALL_ERROR:
            return {
                ...state,
                list: [],
                is_loaded: false
            }
        case actionTypes.ACCIDENTS_FETCH_ONE:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.ACCIDENTS_FETCH_ONE_SUCCESS:
            index = state.list.findIndex(r=>r._id===action.detail._id)
            return {
                ...state,
                detail: action.detail,
                list: [
                    ...state.list.slice(0, index),
                    action.detail,
                    ...state.list.slice(index + 1)
                ],
                is_loaded: true
            }
        case actionTypes.ACCIDENTS_FETCH_ONE_ERROR:
            return {
                ...state,
                detail: null,
                is_loaded: false
            }
        case actionTypes.ACCIDENTS_UPDATE_ONE:
            return {
                ...state,
            }
        case actionTypes.ACCIDENTS_UPDATE_ONE_SUCCESS:
            index = state.list.findIndex(r=>r._id===action.accident._id)
            return {
                ...state,
                detail: action.accident,
                list: [
                    ...state.list.slice(0, index),
                    action.accident,
                    ...state.list.slice(index + 1)
                ],
            }
        case actionTypes.ACCIDENTS_UPDATE_ONE_ERROR:
            return {
                ...state,
            }
        default:
            return state;
    }
}
